function isEmpty(obj) {
	for (const key in obj) {
		return false;
	}
	return true;
}

function swapRemoveByValue(arr, value) {
	const index = arr.indexOf(value);
	if (index === -1) return;
	arr[index] = arr[arr.length ? arr.length - 1 : 0];
	arr.pop();
}

/**
 * Entities are organized by sector
 * every entity added should have a sector = [x, y] property
 * when the space sector then gets unloaded because it moves
 * out of visibility, the entity manager removes all entities
 * by sector (and even triggers their meshes disposal if they
 * have a mesh property)
 */
export default class Entities {
	sectors = {};
	types = {};
	meshes = {};
	ids = {};

	add(entity) {
		if (!entity.sector) {
			console.error(entity);
			throw Error('Entity without sector.');
		}
		const [x, y] = entity.sector;
		if (!this.sectors[x]) {
			this.sectors[x] = {};
		}
		if (!this.sectors[x][y]) {
			this.sectors[x][y] = [];
		}
		this.sectors[x][y].push(entity);

		const { $type } = entity;
		if ($type) {
			if (!this.types[$type]) {
				this.types[$type] = [];
			}
			this.types[$type].push(entity);

			if (entity.mesh) {
				if (!this.meshes[$type]) {
					this.meshes[$type] = [];
				}
				this.meshes[$type].push(entity.mesh);
			}
		}

		const { _id } = entity;
		if (_id) {
			this.ids[_id] = entity;
		}
	}

	clearSector([x, y], { keepUnits = false } = {}) {
		if (this.sectors[x] && this.sectors[x][y]) {
			for (let i = this.sectors[x][y].length - 1; i >= 0; i--) {
				const entity = this.sectors[x][y][i];
				// units are broadcast-managed state — map cleanup must not delete
				// them (parked units get no broadcast and would never come back)
				if (keepUnits && entity.$type === 'unit') continue;
				this.remove(entity);
			}
		}
	}

	remove(mixed) {
		const entity =
			typeof mixed === 'string'
				? this.ids[mixed] // assuming mixed is _id
				: mixed; // assuming mixed is entity

		if (!entity) return;

		const [x, y] = entity.sector;

		swapRemoveByValue(this.sectors[x][y], entity);
		this.sectors[x][y].length === 0 && delete this.sectors[x][y];
		isEmpty(this.sectors[x]) && delete this.sectors[x];

		swapRemoveByValue(this.types[entity.$type], entity);
		if (isEmpty(this.types[entity.$type])) {
			delete this.types[entity.$type];
		}

		const { _id } = entity;
		// only drop the id entry if it still points at THIS entity: a newer entity
		// with the same id (planet tier rebuilds re-register their city labels
		// before the old ones are retired) must keep its lookup
		if (_id && this.ids[_id] === entity) {
			delete this.ids[_id];
		}

		if (entity.mesh) {
			swapRemoveByValue(this.meshes[entity.$type], entity.mesh);
			if (isEmpty(this.meshes[entity.$type])) {
				delete this.meshes[entity.$type];
			}
			game.disposeHierarchy(entity.mesh);
		}
	}

	getSector([x, y]) {
		return this.sectors?.[x]?.[y] || [];
	}

	getSectorAndNeighbors([x, y]) {
		return [
			this.getSector([x, y]),
			this.getSector([x + 1, y]),
			this.getSector([x - 1, y]),
			this.getSector([x, y + 1]),
			this.getSector([x, y - 1]),
			this.getSector([x + 1, y - 1]),
			this.getSector([x - 1, y + 1]),
		].flat();
	}

	getType(type) {
		if (this.types[type]) {
			return this.types[type];
		}
		return [];
	}

	clearAll() {
		for (const x of Object.keys(this.sectors)) {
			for (const y of Object.keys(this.sectors[x])) {
				this.clearSector([x, y]);
			}
		}
	}

	/*ensure(entity, useClass, ...params) {
		if (this.ids[entity._id]) {
			return this.ids[entity._id];
		}
		if (useClass) {
			entity = new useClass(entity, ...params);
		}
		this.add(entity);
		return entity;
	}*/
}
